<template>
  <v-container>
    <v-card elevation="1">
      <v-card-title class="primary darken-1 white--text font-weight-bold justify-center">
        <v-icon class="mr-2" color="white">mdi-database-export-outline</v-icon>
        Select and Export Data
      </v-card-title>
      <v-card-title class="pa-8">
        <v-layout row wrap>
          <v-row>
            <v-col>
              <v-menu
                  v-model="startDateMenu"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="startDate"
                      dense
                      hint="Last update from"
                      label="Start From:"
                      outlined
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="startDate"
                    :max="maxDate"
                    :min="minDate"
                    no-title
                    @input="startDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-menu
                  v-model="endDateMenu"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="dateTo"
                      dense
                      hint="Last update to"
                      label="To:"
                      outlined
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="dateTo"
                    :max="maxDate"
                    :min="minDate"
                    no-title
                    @input="endDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <v-row class="pr-4 pt-2" justify="end">
            <v-btn
                class="mr-2"
                color="primary"
                @click="dataExportCSV"
            >
              <v-icon left>mdi-microsoft-excel</v-icon>
              Export Report to CSV
            </v-btn>
            <v-btn color="primary" @click="dataExportJSON">
              <v-icon left>mdi-file-export</v-icon>
              Export Data for Import
            </v-btn>
          </v-row>
        </v-layout>
      </v-card-title>
      <v-divider class="my-2"></v-divider>
      <v-card-subtitle v-if="error_message" class="white--text error"
      >{{ error_message }}
      </v-card-subtitle>
      <v-card-text>
        <v-tabs
            v-model="tab"
            background-color="primary darken-3"
            dark
            grow
        >
          <v-tab
              v-for="item in items"
              :key="item"
              class="font-weight-bold"
          >
            {{ item }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item
              v-for="(item,index) in items"
              :key="item"
          >
            <v-card
                color="basil"
                flat
            >
              <v-card-text>
                <v-data-table
                    v-model="selected[index].data"
                    :footer-props="{ 'items-per-page-options': itemsPerPage }"
                    :headers="getHeaders(item)"
                    :items="getItems(item)"
                    :loading="loading"
                    :options.sync="options"
                    class="elevation-1 mt-3"
                    item-key="id"
                    show-select
                    style="cursor: pointer"
                ></v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import axios from "axios";

export default {
  name: 'Export',
  created() {
    this.getData();
  },
  data: function () {
    return {
      tab: null,
      items: [
        'Persons', 'Position', 'Performance Evaluation', "DepartmentORCaseteam", "Job Position Stock"
      ],
      downloading: false,
      error_message: null,
      startDateMenu: false,
      endDateMenu: false,
      startDate: this.$moment().subtract("months", 1).format('YYYY-MM-DD'),
      dateTo: this.$moment().format('YYYY-MM-DD'),
      personsHeader: [],
      personsData: [],
      positionHeader: [],
      positionData: [],
      performanceHeader: [],
      performanceData: [],
      departmentHeader: [],
      departmentData: [],
      jobPositionHeader: [],
      jobPositionData: [],
      selected: [
        {
          name: "Persons",
          headers: [],
          data: []
        },
        {
          name: "Position",
          headers: [],
          data: []
        },
        {
          name: "Performance Evaluation",
          headers: [],
          data: []
        },
        {
          name: "DepartmentORCaseteam",
          headers: [],
          data: []
        },
        {
          name: "Job Position Stock",
          headers: [],
          data: []
        },
      ],
      options: {itemsPerPage: 10},
      loading: false,
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    getData() {
      this.loading = true
      axios.get(`/es/exportData`, {
        params: this.axiosParams,
      }).then(({data}) => {
        this.personsHeader = data.exportData.practitioner.headers;
        this.personsData = data.exportData.practitioner.data;
        this.positionHeader = data.exportData.practitionerRole.headers;
        this.positionData = data.exportData.practitionerRole.data;
        this.performanceHeader = data.exportData.PerformanceEvaluation.headers;
        this.performanceData = data.exportData.PerformanceEvaluation.data;
        this.departmentHeader = data.exportData.department.headers
        this.departmentData = data.exportData.department.data
        this.jobPositionHeader = data.exportData.jobPositionStock.headers
        this.jobPositionData = data.exportData.jobPositionStock.data
        this.loading = false
      })
          .catch(error => {
            this.loading = false
            this.error_message = error.message
          })
    },
    getHeaders(item) {
      if (item === "Persons") {
        this.selected[0].headers = this.personsHeader
        return this.personsHeader
      }
      if (item === "Position") {
        this.selected[1].headers = this.positionHeader
        return this.positionHeader
      }
      if (item === "Performance Evaluation") {
        this.selected[2].headers = this.performanceHeader
        return this.performanceHeader
      }
      if(item === "DepartmentORCaseteam"){
        this.selected[3].headers = this.departmentHeader
        return this.departmentHeader
      }
      if(item === "Job Position Stock"){
        this.selected[4].headers = this.jobPositionHeader
        return this.jobPositionHeader
      }
    },
    getItems(item) {
      if (item === "Persons") {
        return this.personsData
      }
      if (item === "Position") {
        return this.positionData
      }
      if (item === "Performance Evaluation") {
        return this.performanceData
      }
      if(item === "DepartmentORCaseteam"){
        return this.departmentData
      }
      if(item === "Job Position Stock"){
        return this.jobPositionData
      }
    },
    dataExportCSV() {
      let data = this.getDataToExport()
      axios.post(`/utils/exportExcel`, data, {
        responseType: "blob",
      })
          .then((response) => {
            console.log(response)
            let blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `Exported_from_HRA_offline_at_${new Date().toISOString()}.xlsx`
            link.click();
            this.loadingId = false;
          })
          .catch((e) => {
            console.log(e);
            this.loadingId = false;
          });
    },
    dataExportJSON() {
      let result = this.getDataToExport()
      let data = this.formatForJSONExport(result)
      axios.post(`/utils/exportJSON`, data, {
        responseType: "blob",
      })
          .then((response) => {
            let blob = new Blob([response.data], {type: "application/json"});
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = `Exported_from_HRA_offline_at_${new Date().toISOString()}.json`
            link.click();
            this.loadingId = false;
          })
          .catch((e) => {
            console.log(e);
            this.loadingId = false;
          });
    },
    formatForJSONExport(selected) {
      let data = [];
      for (let b of selected) {
        let ids = b.data.map(a => ({practitionerId: a.practitionerId, id: a.id,}))
        if (b.name === "Persons") {
          ids = b.data.map(a => ({id: a.id,}))
        }
        ids = b.data.map(a => ({practitionerId: a.practitionerId, id: a.id,}))
        switch (b.name) {
          case "Persons":
            data.push({
              resourceType: "Practitioner",
              _profile:
                  "http://ihris.org/fhir/StructureDefinition/ihris-personal-information",
              data: ids
            })
            break
          case "Position":
            data.push({
              resourceType: "PractitionerRole",
              _profile:
                  "http://ihris.org/fhir/StructureDefinition/ihris-job-description",
              data: ids
            })
            break
          case "Performance Evaluation":
            data.push({
              resourceType: "Basic",
              _profile:
                  "http://ihris.org/fhir/StructureDefinition/ihris-basic-performance",
              data: ids
            })
            break
          case "DepartmentORCaseteam":
            data.push({
              resourceType: "Organization",
              _profile:
                  "http://ihris.org/fhir/StructureDefinition/ihris-organization",
              data: ids
            })
            break
          case "Job Position Stock":
            data.push({
              resourceType: "Basic",
              _profile:
                  "http://ihris.org/fhir/StructureDefinition/ihris-manage-position",
              data: ids
            })
            break
        }
      }
      return data;
    },
    getDataToExport() {
      let data = []
      let returnAll = true;
      for (let a of this.selected) {
        if (a.data.length > 0) {
          returnAll = false;
        }
      }
      if (returnAll) {
        data = [
          {
            name: "Persons",
            headers: this.personsHeader,
            data: this.personsData
          },
          {
            name: "Position",
            headers: this.positionHeader,
            data: this.positionData
          },
          {
            name: "Performance Evaluation",
            headers: this.performanceHeader,
            data: this.performanceData
          },
          {
            name: "DepartmentORCaseteam",
            headers: this.departmentHeader,
            data: this.departmentData
          },
          {
            name: "Job Position Stock",
            headers: this.jobPositionHeader,
            data: this.jobPositionData
          },
        ]
      } else {
        data = this.selected
      }

      return data;
    },
  },
  computed: {
    minDate() {
      return this.$moment().subtract("years", 1).format("YYYY-MM-DD")
    },
    maxDate() {
      return this.$moment().format("YYYY-MM-DD")
    },
    itemsPerPage() {
      return [5, 10, 20, 50];
    },
    axiosParams() {
      const params = new URLSearchParams();
      params.append('startDate', this.startDate);
      params.append('endDate', this.dateTo);
      return params;
    }
  },
  watch: {
    selected() {
      // if (this.selected.length !== this.results.length && this.selectAll) {
      //   this.selectAll = false;
      // }
      console.log(this.selected)
    },
    startDate() {
      this.getData()
    },
    dateTo() {
      this.getData()
    }
  }
}
</script>

<style>
.basil {
  background-color: #FFFBE6 !important;
}
</style>